export { default } from './SettingSubMerchant';
